import cx from 'classnames';
import styles from './WinnersTextWithStars.module.scss';
import { Typography } from '@shared/Typography';
import { StarSvg } from '@assets/svg';
import {
  getTicketLabelTextWinning,
  getTicketClassName,
} from '@features/LotteryGame/helpers/ticketNumberUtils';
import { SuperTicketType } from '@features/LotteryGame/types';

interface WinnersTextWithStarsProps {
  className?: string;
  luckyTicketNumber?: string;
}

export const WinnersTextWithStars = ({
  className,
  luckyTicketNumber,
}: WinnersTextWithStarsProps) => {
  const type = luckyTicketNumber as SuperTicketType;

  const titleText = getTicketLabelTextWinning(type);
  const ticketStyleClass = getTicketClassName(type);

  return (
    <div className={cx(styles.winnersContainer, className)}>
      <Typography
        component="h1"
        textTransform="uppercase"
        className={cx(styles.winnersText, styles[ticketStyleClass!])}
      >
        <StarSvg className={styles.winnersStarLeft} />
        {titleText}
        <StarSvg className={styles.winnersStarMiddle} />
        <StarSvg className={styles.winnersStarRight} />
      </Typography>
    </div>
  );
};
